import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.714 1.952a.952.952 0 0 0-1.904 0v3.81H5.19a1.19 1.19 0 0 0-.238 2.357v6.214a6.667 6.667 0 1 0 13.334 0V8.12a1.19 1.19 0 0 0-.238-2.357h-2.62v-3.81a.952.952 0 0 0-1.904 0v3.81h-3.81zm2.85 8.051a.357.357 0 0 0-.616-.313L7.9 14.214a.357.357 0 0 0 .267.595h3.13l-.622 2.902a.357.357 0 0 0 .615.313l4.048-4.524a.357.357 0 0 0-.267-.595h-3.13z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }